<template>
    <div>
        <NewsModal  @close="newsModalOpen = false" v-if="newsModalOpen" :type="type" :message="message" :date="dateNews" :id="id" />
        <NewsGetter @create="createMessage" :url="url" :type="type"/>
    </div>
</template>
<script>
import NewsGetter from './news-getter';
import NewsModal from './news-modal';

export default {
  name: 'newsHandler',
  props: ['url', 'type'],
  components: {
    NewsGetter, NewsModal,
  },
  data() {
    return {
      newsModalOpen: false,
      message: '',
      dateNews: '',
      id: '',
    };
  },
  methods: {
    createMessage(date, msg, id) {
      this.message = msg;
      this.dateNews = date;
      this.id = id;
      setTimeout(() => { this.newsModalOpen = true; }, 1000);
    },
  },
};
</script>
